import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMfaSummaryData } from 'src/apps/mfa/services/MfaDashboardService';
import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { IMfaSessionsFilterOption } from 'src/common/helpers/DataFilterHelper';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';
import { MFA_SUMMARY_DATA } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMfaSummaryDataQuery = (
	filters: IMfaSessionsFilterOption
): UseQueryResult<SummaryItem[]> => {
	const query = useQuery(
		[MFA_SUMMARY_DATA, filters],
		async (): Promise<SummaryItem[]> => getMfaSummaryData(filters),
		{
			refetchInterval: REFETCH_INTERVAL
		}
	);

	return query;
};
